export default "__VITE_ASSET__CDVuQTV___"